import type { BaseBodyResponse } from "./interfaces";
import { API_BASE_URL } from "../env";
import { getToken } from "../token";

const requestApi = async <T, B = unknown>(
    path: string,
    method: "POST" | "GET" = "GET",
    payload?: B
) => {
    const url = `${API_BASE_URL}${path}`;
    const body = payload ? JSON.stringify(payload) : undefined;
    const token = getToken();
    const response = await fetch(url, {
        method,
        body,
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: token ? `Token ${token}` : "",
        },
    });
    const json = await response.json();

    // @TODO: clean up
    // if (!response.ok) {
    //     throw new Error(json.error);
    // }

    return json as BaseBodyResponse<T>;
};

export default requestApi;
